export enum FollowUpWorkStatus {    
    FullTime = 3,
    PartTime = 2,
    NotWorking = 1
}